import React from "react";

function StarIcon() {
  return (
    <svg
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9444 10.1111L15.7691 13.2863C14.2293 17.4501 13.4594 19.532 11.9402 21.0513C10.4209 22.5706 8.339 23.3404 4.17522 24.8802L1 26.0556L4.17522 27.2309C8.339 28.7707 10.4209 29.5428 11.9402 31.0598C13.4594 32.5768 14.2293 34.661 15.7691 38.8248L16.9444 42L18.1198 38.8248C19.6596 34.661 20.4317 32.5791 21.9487 31.0598C23.4657 29.5406 25.5499 28.7707 29.7137 27.2309L32.8889 26.0556L29.7137 24.8802C25.5499 23.3404 23.468 22.5706 21.9487 21.0513C20.4294 19.532 19.6596 17.4501 18.1198 13.2863L16.9444 10.1111ZM35.1667 1L34.6633 2.35983C34.0027 4.14561 33.6724 5.0385 33.0233 5.68767C32.3718 6.33911 31.4789 6.66939 29.6932 7.32767L28.3333 7.83333L29.6954 8.33672C31.4789 8.99728 32.3718 9.32756 33.021 9.97672C33.6724 10.6282 34.0027 11.5211 34.661 13.3068L35.1667 14.6667L35.6701 13.3068C36.3306 11.5211 36.6609 10.6282 37.3101 9.979C37.9615 9.32755 38.8544 8.99728 40.6402 8.339L42 7.83333L40.6379 7.32994C38.8544 6.66939 37.9615 6.33911 37.3123 5.68994C36.6609 5.0385 36.3306 4.14561 35.6723 2.35983L35.1667 1Z"
        stroke="#4072C8"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default StarIcon;
